export default "__VITE_ASSET__BwTsOxwW__"